module.exports = __webpack_public_path__ + "static/media/the-beers-thumb.8318b941.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/beers/the-beers-thumb.jpg
// module id = 581
// module chunks = 0